import { SxProps } from "@mui/material";

export const UserAvatarMenuText: SxProps = {
  fontFamily: "Manrope",
  color: "#3c3c40",
  textTransform: "capitalize",
  fontWeight: 600,
  paddingLeft: "10px",
  fontSize: "16px",
};
